/**
 *    @author:
 *    @since:
 *
 */

import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { InputData } from '../_common/data/input-data';
import { Path } from  "../_common/constant/page-const";
import { ViewportScroller } from '@angular/common';
import { CommonService } from 'src/refresh/service/common-service';
import { AccordionComponent } from 'src/refresh/layout/accordion/accordion.component';

@Component({ 
      selector: 'FAQ',
      templateUrl: './FAQ.component.html',
      styleUrls: ['./FAQ.component.less'],
      //encapsulation: ViewEncapsulation.None
})
export class FAQComponent extends FormBaseComponent implements OnInit {

      public whoCanBeListed:boolean = false;
      public whatAreTheFee:boolean = false;
      public birthCertificate:boolean = false;
      public whatIsBCFaq: boolean = false;
      public faqSIN: boolean = false;
      public faqCCB: boolean = false;
      public faqESR: boolean = false;


      constructor( protected router: Router ,
            public timerService:TimerService,
            public data:InputData,
            private viewportScroller: ViewportScroller,
            private commonService: CommonService ) {

            super(router,timerService);  
            super.setNextPage(Path.ORGContactInformation,null);

            this.commonService.setCloseAllFAQ( () => {
                 this.closeAll();
            });
      }

      public linkOnSamePage(elementId: string, event){
            event.preventDefault();
            if(elementId === 'whoCanBeListed'){
                  this.whoCanBeListed = true;
            } else if(elementId === 'whatAreTheFee'){
                  this.birthCertificate = true;
                  this.whatAreTheFee = true;
            }
            this.elementScroll(elementId);
      }
      
      public onClick(elementId: string, subElementId? : string): void { 
            if(elementId === 'birthCertificate'){
                  this.birthCertificate = true;
                  if(subElementId === 'whatIsBCFaq'){
                        this.whatIsBCFaq = true;
                  }
            } else if(elementId === 'faqSIN'){
                  this.faqSIN = true;
            } else if(elementId === 'faqCCB'){
                  this.faqCCB = true;
            } else if(elementId === 'faqESR'){
                  this.faqESR = true;
            }
            if(subElementId != ''){
                  this.elementScroll(subElementId);
            } else {
                  this.elementScroll(elementId);
            }
      }

      public elementScroll(elementId: string){
            this.viewportScroller.scrollToAnchor(elementId);
            document.getElementById(elementId).tabIndex = -1;
            setTimeout(function(){ 
                  document.getElementById(elementId).classList.add("remove-focus");
                  document.getElementById(elementId).focus();
                  
            }, 200);
       }

      public ngOnInit() {
            //listen on FAQ expand call from any part of the application and click to expand.
            this.commonService.getFaqSectionToExpand().subscribe((e) => {
                  this.onClick(e['faqHeader'], e['faqSubHeader']);        
            });
      }

      closeLightbox() {
            this.commonService.closeLightBox();
      }


      @ViewChild('acc_01') acc_01: AccordionComponent;
      @ViewChild('acc_02') acc_02: AccordionComponent;
      @ViewChild('acc_03') acc_03: AccordionComponent;
      @ViewChild('acc_04') acc_04: AccordionComponent;
      @ViewChild('acc_05') acc_05: AccordionComponent;
      @ViewChild('acc_06') acc_06: AccordionComponent;
      @ViewChild('acc_07') acc_07: AccordionComponent;
      @ViewChild('acc_08') acc_08: AccordionComponent;
      @ViewChild('acc_09') acc_09: AccordionComponent;
      @ViewChild('acc_10') acc_10: AccordionComponent;
      @ViewChild('acc_11') acc_11: AccordionComponent;
      @ViewChild('acc_12') acc_12: AccordionComponent;
      @ViewChild('acc_13') acc_13: AccordionComponent;
      @ViewChild('acc_14') acc_14: AccordionComponent;
      @ViewChild('acc_15') acc_15: AccordionComponent;
      @ViewChild('acc_16') acc_16: AccordionComponent;
      @ViewChild('acc_17') acc_17: AccordionComponent;
      @ViewChild('acc_18') acc_18: AccordionComponent;
      @ViewChild('acc_19') acc_19: AccordionComponent;
      @ViewChild('acc_20') acc_20: AccordionComponent;
      @ViewChild('acc_21') acc_21: AccordionComponent;
      @ViewChild('acc_22') acc_22: AccordionComponent;
      @ViewChild('acc_23') acc_23: AccordionComponent;
      @ViewChild('acc_24') acc_24: AccordionComponent;
      @ViewChild('acc_25') acc_25: AccordionComponent;
      @ViewChild('acc_26') acc_26: AccordionComponent;
      @ViewChild('acc_27') acc_27: AccordionComponent;
      @ViewChild('acc_28') acc_28: AccordionComponent;
      @ViewChild('acc_29') acc_29: AccordionComponent;
      @ViewChild('acc_30') acc_30: AccordionComponent;
      @ViewChild('acc_31') acc_31: AccordionComponent;
      @ViewChild('acc_32') acc_32: AccordionComponent;
      @ViewChild('acc_33') acc_33: AccordionComponent;
      @ViewChild('acc_34') acc_34: AccordionComponent;
      @ViewChild('acc_35') acc_35: AccordionComponent;
      @ViewChild('acc_36') acc_36: AccordionComponent;
      @ViewChild('acc_37') acc_37: AccordionComponent;
      @ViewChild('acc_38') acc_38: AccordionComponent;
      @ViewChild('acc_39') acc_39: AccordionComponent;
      @ViewChild('acc_40') acc_40: AccordionComponent;
      @ViewChild('acc_41') acc_41: AccordionComponent;
      @ViewChild('acc_42') acc_42: AccordionComponent;
      @ViewChild('acc_43') acc_43: AccordionComponent;
      @ViewChild('acc_44') acc_44: AccordionComponent;
      @ViewChild('acc_45') acc_45: AccordionComponent;
      @ViewChild('acc_46') acc_46: AccordionComponent;
      @ViewChild('acc_47') acc_47: AccordionComponent;
      @ViewChild('acc_48') acc_48: AccordionComponent;
      @ViewChild('acc_49') acc_49: AccordionComponent;
      @ViewChild('acc_50') acc_50: AccordionComponent;
      @ViewChild('acc_51') acc_51: AccordionComponent;
      @ViewChild('acc_52') acc_52: AccordionComponent;
      @ViewChild('acc_53') acc_53: AccordionComponent;
      @ViewChild('acc_54') acc_54: AccordionComponent;
      @ViewChild('acc_55') acc_55: AccordionComponent;
      @ViewChild('acc_56') acc_56: AccordionComponent;
      @ViewChild('acc_57') acc_57: AccordionComponent;
      @ViewChild('acc_58') acc_58: AccordionComponent;
      @ViewChild('acc_59') acc_59: AccordionComponent;
      @ViewChild('acc_60') acc_60: AccordionComponent;
      @ViewChild('acc_61') acc_61: AccordionComponent;
      @ViewChild('acc_62') acc_62: AccordionComponent;
      @ViewChild('acc_63') acc_63: AccordionComponent;
      @ViewChild('acc_64') acc_64: AccordionComponent;
      @ViewChild('acc_65') acc_65: AccordionComponent;
      @ViewChild('acc_66') acc_66: AccordionComponent;
      @ViewChild('acc_67') acc_67: AccordionComponent;
      @ViewChild('acc_68') acc_68: AccordionComponent;
      @ViewChild('acc_69') acc_69: AccordionComponent;
      @ViewChild('acc_70') acc_70: AccordionComponent;
      @ViewChild('acc_71') acc_71: AccordionComponent;
      @ViewChild('acc_72') acc_72: AccordionComponent;
      @ViewChild('acc_73') acc_73: AccordionComponent;
      @ViewChild('acc_74') acc_74: AccordionComponent;
      @ViewChild('acc_75') acc_75: AccordionComponent;
      @ViewChild('acc_76') acc_76: AccordionComponent;
      @ViewChild('acc_77') acc_77: AccordionComponent;
      @ViewChild('acc_78') acc_78: AccordionComponent;

      public closeAll() {
              this.acc_01.close();
              this.acc_02.close();
              this.acc_03.close();
              this.acc_04.close();
              this.acc_05.close();
              this.acc_06.close();
              this.acc_07.close();
              this.acc_08.close();
              this.acc_09.close();
              this.acc_10.close();
              this.acc_11.close();
              this.acc_12.close();
              this.acc_13.close();
              this.acc_14.close();
              this.acc_15.close();
              this.acc_16.close();
              this.acc_17.close();
              this.acc_18.close();
              this.acc_19.close();
              this.acc_20.close();
              this.acc_21.close();
              this.acc_22.close();
              this.acc_23.close();
              this.acc_24.close();
              this.acc_25.close();
              this.acc_26.close();
              this.acc_27.close();
              this.acc_28.close();
              this.acc_29.close();
              this.acc_30.close();
              this.acc_31.close();
              this.acc_32.close();
              this.acc_33.close();
              this.acc_34.close();
              this.acc_35.close();
              this.acc_36.close();
              this.acc_37.close();
              this.acc_38.close();
              this.acc_39.close();
              this.acc_40.close();
              this.acc_41.close();
              this.acc_42.close();
              this.acc_43.close();
              this.acc_44.close();
              this.acc_45.close();
              this.acc_46.close();
              this.acc_47.close();
              this.acc_48.close();
              this.acc_49.close();
              this.acc_50.close();
              this.acc_51.close();
              this.acc_52.close();
              this.acc_53.close();
              this.acc_54.close();
              this.acc_55.close();
              this.acc_56.close();
              this.acc_57.close();
              this.acc_58.close();
              this.acc_59.close();
              this.acc_60.close();
              this.acc_61.close();
              this.acc_62.close();
              this.acc_63.close();
              this.acc_64.close();
              this.acc_65.close();
              this.acc_66.close();
              this.acc_67.close();
              this.acc_68.close();
              this.acc_69.close();
              this.acc_70.close();
              this.acc_71.close();
              this.acc_72.close();
              this.acc_73.close();
              this.acc_74.close();
              this.acc_75.close();
              this.acc_76.close();
              this.acc_77.close();
              this.acc_78.close();
      }
     
}
